import { WarmUpPickerParams } from '@wix/bex-core';
import { Essentials } from '@wix/fe-essentials/core';
import { buildWixPatternsEssentials } from './buildWixPatternsEssentials';
import { warmUpPickerStandalone as warmUpPickerStandaloneBase } from '../state/warmUpPickerStandalone';

export function warmUpPickerStandalone(
  essentials: Essentials,
  params: WarmUpPickerParams,
) {
  warmUpPickerStandaloneBase(buildWixPatternsEssentials(essentials), params);
}
